// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.prompt_modal-content_dBaQs {
    width: 360px;
}

.prompt_body_mqAmR {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
}

.prompt_body_mqAmR input[type="checkbox"],
.prompt_body_mqAmR input[type="radio"] {
    margin: 3px;
}

.prompt_label_F6Gcq {
    font-weight: 500;
    margin: 0 0 0.75rem;
}

.prompt_disabled-label_u1cpz {
    opacity: 0.5;
}

.prompt_variable-name-text-input_Ow7Er {
    margin-bottom: 1.5rem;
    width: 100%;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 5px;
    padding: 0 1rem;
    height: 3rem;
    color: var(--ui-text-primary-transparent);
    background-color: var(--input-background);
    font-size: .875rem;
}

.prompt_info-message_D2g4F {
    font-weight: normal;
    font-size: .875rem;
    margin-bottom: 1.5rem;
    text-align: center;
}

.prompt_options-row_UKTQ5 {
    display: flex;
    font-weight: normal;
    justify-content: space-between;
    margin-bottom: 1.5rem;
}

.prompt_button-row_RnHSp {
    font-weight: bolder;
    text-align: right;
}

.prompt_button-row_RnHSp button {
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    background: white;
    color: black;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
}

.prompt_button-row_RnHSp button.prompt_ok-button_YVC6_ {
    background: var(--looks-secondary);
    border: var(--looks-secondary);
    color: white;
}

[dir="ltr"] .prompt_button-row_RnHSp button + button {
    margin-left: 0.5rem;
}

[dir="rtl"] .prompt_button-row_RnHSp button + button {
    margin-right: 0.5rem;
}

.prompt_cloud-option_WDOAq {
    display:flex;
    border-top: 1px dashed var(--ui-black-transparent);
    overflow: visible;
    padding: 1rem 0;
    text-align: center;
    width: 100%;
    margin: 0 auto;
}

.prompt_cloud-option-text_XJgGB {
    opacity: .5;
}
`, "",{"version":3,"sources":["webpack://./src/components/prompt/prompt.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yCAAyC;IACzC,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,kDAAkD;IAClD,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n    width: 360px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n}\n\n.body input[type=\"checkbox\"],\n.body input[type=\"radio\"] {\n    margin: 3px;\n}\n\n.label {\n    font-weight: 500;\n    margin: 0 0 0.75rem;\n}\n\n.disabled-label {\n    opacity: 0.5;\n}\n\n.variable-name-text-input {\n    margin-bottom: 1.5rem;\n    width: 100%;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 5px;\n    padding: 0 1rem;\n    height: 3rem;\n    color: var(--ui-text-primary-transparent);\n    background-color: var(--input-background);\n    font-size: .875rem;\n}\n\n.info-message {\n    font-weight: normal;\n    font-size: .875rem;\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n\n.options-row {\n    display: flex;\n    font-weight: normal;\n    justify-content: space-between;\n    margin-bottom: 1.5rem;\n}\n\n.button-row {\n    font-weight: bolder;\n    text-align: right;\n}\n\n.button-row button {\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    background: white;\n    color: black;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n}\n\n.button-row button.ok-button {\n    background: var(--looks-secondary);\n    border: var(--looks-secondary);\n    color: white;\n}\n\n[dir=\"ltr\"] .button-row button + button {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-row button + button {\n    margin-right: 0.5rem;\n}\n\n.cloud-option {\n    display:flex;\n    border-top: 1px dashed var(--ui-black-transparent);\n    overflow: visible;\n    padding: 1rem 0;\n    text-align: center;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.cloud-option-text {\n    opacity: .5;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `prompt_modal-content_dBaQs`;
export { _1 as "modal-content" };
export var modalContent = `prompt_modal-content_dBaQs`;
export var body = `prompt_body_mqAmR`;
export var label = `prompt_label_F6Gcq`;
var _2 = `prompt_disabled-label_u1cpz`;
export { _2 as "disabled-label" };
export var disabledLabel = `prompt_disabled-label_u1cpz`;
var _3 = `prompt_variable-name-text-input_Ow7Er`;
export { _3 as "variable-name-text-input" };
export var variableNameTextInput = `prompt_variable-name-text-input_Ow7Er`;
var _4 = `prompt_info-message_D2g4F`;
export { _4 as "info-message" };
export var infoMessage = `prompt_info-message_D2g4F`;
var _5 = `prompt_options-row_UKTQ5`;
export { _5 as "options-row" };
export var optionsRow = `prompt_options-row_UKTQ5`;
var _6 = `prompt_button-row_RnHSp`;
export { _6 as "button-row" };
export var buttonRow = `prompt_button-row_RnHSp`;
var _7 = `prompt_ok-button_YVC6_`;
export { _7 as "ok-button" };
export var okButton = `prompt_ok-button_YVC6_`;
var _8 = `prompt_cloud-option_WDOAq`;
export { _8 as "cloud-option" };
export var cloudOption = `prompt_cloud-option_WDOAq`;
var _9 = `prompt_cloud-option-text_XJgGB`;
export { _9 as "cloud-option-text" };
export var cloudOptionText = `prompt_cloud-option-text_XJgGB`;
export default ___CSS_LOADER_EXPORT___;
